import Router from "preact-router";
import Layout from "../components/Layout";
import Home from "../components/Home";
import Credential from "../components/Credential";
import NotFound from "../components/NotFound";

export default function App() {
  return (
    <Layout>
      <Router>
        <Home path="/" />
        <Credential path="/badge/:id" />
        <NotFound default />
      </Router>
    </Layout>
  );
}